<template>
  <div class="wrap">

    <Head />
    <div class="part1">
      <p class="tit">区块链农村三资监管平台</p>
      <p class="txt">通过区块链汇集农村“三资”基础信息，统一各“三资”系统操作人员的区块链身份，建立标准的“三资”数字凭证，通过智能合约实现对“三资”管理中的违规事项进行预警和报警。实现对“三资”领域“人”、“物”、“事”的贯穿式监管</p>
      <div class="img">
        <img
          src="../../../assets/images/mobile/solution/part1-4.png"
          alt=""
        >
      </div>
    </div>

    <div class="part2">
      <p class="tit">方案介绍</p>
      <div
        class="show"
        id="show"
        style="height:auto"
      >
        <div class="line">
          恒为信息科技将区块链技术应用于农村“三资”监管领域，整合“三资”监管领域的多套应用系统，形成一套完整可信的“三资”基础数据。通过区块链账户，为各系统中的人员建立统一的区块链身份，同一个人员在不同系统的操作行为，将在链上留下完整的行为痕迹，从而实现对“三资”监管中“人”的穿透式监管。通过区块链可信数字凭证，将资产、资源、资金数字凭证化，数字凭证在不同系统间的转化均在链上存证，从而实现了对三资监管中“物”的全生命周期管理。基于完整可信的数据存证和公开透明的智能合约，能够准确地分析出“三资”管理中存在的异常信息，为农村基层工作人员提供办事提醒，为“三资”领域的监管人员提供监督预警和报警。基于“人”的贯穿式行为留痕，和“物”的全生命周期管理，能够为“三资”领域问题的线上核查提供完整的、不可篡改的依据，大大提高问题核查能力与效率，从而实现对“三资”管理过程中权力运行的有效监管。
        </div>
      </div>
      <div
        class="btn"
        v-show="show"
      >
        <div class="btn">
          <p
            @click="getChange('more')"
            v-show="more"
          >
            <span>查看更多</span>
            <i class="iconfont  iconxia"></i>
          </p>
          <p
            @click="getChange('less')"
            v-show="!more"
          >
            <span>收起</span>
            <i class="iconfont  iconshang"></i>
          </p>
        </div>
      </div>
      <div class="img">
        <img
          src="../../../assets/images/mobile/solution/countryside/part2.png"
          alt=""
        >
      </div>

    </div>

    <div class="part3">
      <p class="tit">方案价值</p>
      <div class="center">
        <div class="card">
          <div class="left">
            <img
              src="../../../assets/images/mobile/solution/countryside/part3-1.png"
              alt=""
            >
          </div>
          <div class="right">
            <p class="title">基层管理人员受益</p>
            <p class="text">
              基于全面的“三资”信息和智能合约提醒机制，大大提高“三资”管理工作效率，避免工作中的疏忽为集体资产造成巨大的损失
            </p>
          </div>
        </div>

        <div class="card">
          <div class="left">
            <img
              src="../../../assets/images/mobile/solution/countryside/part3-2.png"
              alt=""
            >
          </div>
          <div class="right">
            <p class="title">监管部门受益</p>
            <p class="text">
              ：基于准确完整的“三资”信息，能够全面掌握各村集体的“三资”管理情况，针对管理过程中存在的违规行为，能够及时察觉，高效核查
            </p>
          </div>
        </div>

         <div class="card">
          <div class="left">
            <img
              src="../../../assets/images/mobile/solution/countryside/part3-2.png"
              alt=""
            >
          </div>
          <div class="right">
            <p class="title">群众受益</p>
            <p class="text">
              基于区块链公开透明、不可篡改的特点，透明清晰地了解集体资产状态和使用情况，发挥群众监督的作用，维护人民群众的利益
            </p>
          </div>
        </div>
      </div>

    </div>

    <div class="part4">
      <p class="tit">产品核心功能</p>
      <div class="card">
        <div class="img">
          <img
            src="../../../assets/images/mobile/solution/countryside/part4-1.png"
            alt=""
          >
        </div>
        <div class="content">
          <p class="title">苏州相城区三资监管链</p>
          <div class="line">
            苏州相城区利用现有“三资”信息化系统，以不重复建设系统，不大规模改造现有系统，不增加使用人员负担的方式，通过“三资链”建立起完整可信的“三资”账本数据。基于这份账本数据，实现了对“三资”领域“人”、“物”、“事”的贯穿式监管，将现有孤立的“三资”数据发挥出最大的价值。辅助“三资”基层人员更好地管理“三资”，帮助区农业农村局和区纪委实现三资管理工作的监督和再监督。
          </div>
        </div>
      </div>
    </div>

    <Foot />
  </div>
</template>
<script>
import Head from "../../../components/mobile/Head.vue";
import Foot from "../../../components/mobile/Foot.vue";
export default {
  data() {
    return {
      show: false,
      more: true,
    };
  },
  components: {
    Head,
    Foot,
  },
  created() {},
  mounted() {
    this.getShow();
  },
  methods: {
    //判断是否显示加载更多
    getShow() {
      let h = document.getElementById("show").offsetHeight;
      let w = document.body.clientWidth;
      if (h > w * 0.31) {
        this.show = true;
        document.getElementById("show").style.height = "31vw";
      } else {
        this.show = false;
      }
    },
    getChange(type) {
      if (type == "more") {
        this.more = false;
        document.getElementById("show").style.height = "auto";
      } else {
        this.more = true;
        document.getElementById("show").style.height = "31vw";
      }
    },
  },
};
</script>
<style lang="stylus" scoped>
@import '~@/assets/css/mixin';

.wrap {
}

.part1 {
  height: vw(650);
  background: linear-gradient(-30deg, #019EDF, #1CC8E7);
  position: relative;
  part1();
  padding-top: vw(57);

  .tit {
    margin-bottom: vw(22);
    hTit();
  }

  .txt {
    font-size: vw(24);
    line-height: vw(36);
    text-align: center;
    color: #fff;
    padding: 0 vw(70);
  }

  .img {
    width: 100%;
    position: absolute;
    bottom: vw(20);
    text-align: center;

    img {
      width: vw(440);
      height: vw(351);
    }
  }
}

.part2 {
  part();
  background: #fff;

  .tit {
    tit3();
    margin-bottom: vw(30);
  }

  .show {
    overflow: hidden;
    transition: all 0.3s ease;

    .line {
      font-size: vw(28);
      color: #666666;
      line-height: vw(48);
      margin-bottom: vw(30);
      padding: 0 vw(30);
    }
  }

  .btn {
    margin-top: vw(40);

    p {
      width: vw(240);
      height: vw(80);
      background: #fff;
      border-radius: vw(40);
      box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
      text-align: center;
      margin: 0 auto;

      span {
        display: inline-block;
        height: vw(80);
        color: #2A93FF;
        font-size: vw(30);
        line-height: vw(80);
      }

      i {
        margin-left: vw(5);
        display: inline-block;
        height: vw(80);
        font-size: vw(24);
        color: #2A93FF;
        line-height: vw(80);
      }
    }
  }

  .img {
    margin-top: vw(60);
    text-align: center;

    img {
      width: vw(690);
      height: auto;
    }
  }
}

.part3 {
  part();
  background: rgba(249, 249, 249, 1);

  .tit {
    tit3();
    margin-bottom: vw(30);
  }

  .center {
    width: 100%;

    .card {
      display: flex;
      width: vw(690);
      height: vw(241);
      margin: 0 auto vw(30);
      padding: vw(44) vw(45) 0 vw(40);
      background: #fff;
      box-shadow: 0px 0px vw(10) 0px rgba(0, 0, 0, 0.1);

      .left {
        width: vw(179);
        margin-right: vw(37);
        padding-top: vw(14);

        img {
          width: 100%;
          height: auto;
        }
      }

      .right {
        flex: 1;

        .title {
          font-size: vw(32);
          line-height: vw(32);
          margin: vw(4) 0 vw(10);
          color: #444444;
        }

        .text {
          font-size: vw(24);
          color: #888;
          line-height: vw(36);
          showline(3)
        }
      }
    }
  }
}

.part4 {
  part();
  background: #fff;
  padding: vw(80) 0 vw(40);

  .tit {
    tit3();
    margin-bottom: vw(80);
  }

  .card {
    width: vw(690);
    padding: vw(20);
    margin: 0 auto vw(40);
    background: #fff;
    box-shadow: 0px 0px vw(10) 0px rgba(0, 0, 0, 0.1);

    .img {
      text-align: center;

      img {
        width: vw(650);
        height: auto;
      }
    }

    .content {
      margin-top: vw(60);

      .title {
        font-size: vw(32);
        font-weight: 500;
        color: rgba(68, 68, 68, 1);
        line-height: vw(32);
        margin-bottom: vw(30);
        text-align: center;
      }

      .line {
        font-size: vw(24);
        color: #888888;
        line-height: vw(36);
        margin-bottom: vw(40);
      }
    }
  }
}
</style>
